<template>
  <div>
    <b-form @submit.prevent v-if="isAssignable">
      <b-form-row v-if="statusesMap[shipping.status].length > 0 && !shipping.courier_id">
        <div class="form-group col-12" v-if="!courier || !courier.id || (!courier && !shipping.courier_id) || shipping.courier_id === courier.id">
          <user-autocomplete ref="courierAc" :endpoint="endpoint" @selected="onSearchCourierSelected" :placeholder="this.$gettext('Courier name or email')" :restrictToRoles="['courier']" with-picture />
        </div>
        <div class="form-group col-12" v-if="courier && courier.id && shipping.courier_id !== courier.id">
          <user-card :user="courier" :with-titles="false" :with-map="false" />
        </div>
        <div class="form-group col-12">
          <div class="input-group">
            <b-btn size="sm" v-if="courier" @click="assignShipping(shipping.id)" :disabled="!courier.id || shipping.courier_id === courier.id" v-translate>Assign!</b-btn>
            <b-btn variant="warning" size="sm" v-if="allowResetCourier && courier && courier.id && shipping.courier_id !== courier.id" @click="courier = null; shipping.courier_id = null;" :disabled="!courier.id" class="ml-1" v-translate>Search again</b-btn>
          </div>
        </div>
      </b-form-row>
      <div v-else>
        <user-card :user="courier || shipping.courier" />
      </div>
    </b-form>
    <b-alert variant="warning" show v-else v-translate>Shipment is not assignable because of its status.</b-alert>
  </div>
</template>

<script>
import UserAutocomplete from '@/components/Autocompletes/UserAutocomplete'
export default {
  name: 'EditFieldCourier',
  components: {
    UserAutocomplete
  },
  props: {
    shipping: {
      type: Object,
      required: true
    },
    allowResetCourier: {
      type: Boolean,
      default: true
    },
    endpoint: {
      type: String,
      default: 'users'
    }
  },
  data() {
    return {
      courier: null
    }
  },
  computed: {
    isEditable() {
      return this.shipping.company &&
        this.shipping.status !== 'DELIVERED' &&
        this.shipping.status !== 'CANCELED' &&
        this.shipping.status !== 'RETURNED'
    },
    isAssignable() {
      return this.shipping.status === 'WAITING' ||
        this.shipping.status === 'READY' ||
        this.shipping.status === 'INCIDENCE'
    }
  },
  methods: {
    setCourier(element) {
      this.courier = element
    },
    onSearchCourierSelected(item) {
      this.courier = item
      this.$refs.courierAc.searchQuery = ''
    },
    assignShipping(id) {
      let params = {
        shipping_id: id,
        user_id: this.courier.id,
        status: 'CONFIRMED'
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
        .then(response => {
          this.$emit('success', this.courier)
        })
    }
  }
}
</script>
